export default {
  data () {
    let getStatusLabel = (status) => {
      for (let one of this.statusOpts) {
        if (one.key === status) {
          return one.label
        }
      }
    }
    return {
      getStatusLabel,
      statusOpts: [
        {key: 2, label: '疑似翻拍'},
        {key: 3, label: '非翻拍'},
        {key: 4, label: '确认翻拍'},
      ],
      exportHeader: [
        {
          text: '客户',
          key: 'customer_name',
          formatter (row) {
            return row.customer_name + '/' + row.customerid
          }
        },
        {
          text: '项目',
          key: 'project_name',
          formatter (row) {
            return row.project_name + '/' + row.project_number
          }
        },
        {
          text: '批次',
          key: 'batch_name',
          formatter (row) {
            return row.batch_name + '/' + row.batch_number
          }
        },
        {
          text: '拍摄时间',
          key: 'created_at'
        },
        {
          text: '状态',
          key: 'result',
          formatter (row) {
            return getStatusLabel(row.result)
          }
        },
        {
          text: '工单id',
          key: 'orderid'
        },
        {
          text: '题目标题',
          key: 'step_title'
        },
        {
          text: '照片URL',
          key: 'url'
        },
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/order-image-recapture-detection/order-image-recapture-detection.mixins.js